var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.10461,5.37311,8.25775,17.46417c-.82031,2.0882-1.6416,3.5185-4.126,3.5185a6.17318,6.17318,0,0,1-1.053-.08606.9426.9426,0,0,1,.307-1.8476c.02924.00275.48267.02942.61292.02942,1.34783,0,1.93457-.83795,2.56835-2.62762l-4.512-11.0069a1.10052,1.10052,0,0,1,2.04059-.81366L7.678,13.6991h.0534l3.40577-9.00116a1.04027,1.04027,0,0,1,1.96746.67517Zm6.235,2.52612A1.01978,1.01978,0,0,0,18.41632,6.124c-.037.01905-.07544.03968-.11658.06183-.67431.37165-5.23291,3.56561-4.71826,3.92621C14.09253,10.4693,17.20972,9.06653,19.33966,7.89923ZM13.58148,15.2915c-.51465.36017,4.044,3.55481,4.71826,3.92572.04114.02234.07953.04285.11658.0625a1.02013,1.02013,0,0,0,.92334-1.77587C17.20972,16.3371,14.09253,14.93408,13.58148,15.2915Zm7.63458-3.63989c-.04187-.00213-.086-.00256-.13195-.00256-.76947.00146-6.303.60834-6.02539,1.17224.27667.558,3.68408.82886,6.11248.82983a1.01916,1.01916,0,0,0,.04486-1.99951Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYammer);
export default __webpack_public_path__ + "static/media/Yammer.562e24a368e3c41eb9e02062ab88dac9.svg";
export { ForwardRef as ReactComponent };